export enum TextAreaVariant {
  PRIMARY = '--primary',
  READONLY = '--readonly',
  ERROR = '--error',
}
